















import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ChildComponentMixin from '@/common/ts/child-component/ChildComponentMixin';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';

const MetaNavigationFlyoutLinkProps = Vue.extend({
  props: {
    linkUrl: String,
    linkText: String,
    linkTarget: String,
    linkIcon: {
      type: String,
      default: 'arrow-external',
    },
    editMode: Boolean,
  },
});

@Component
export default class MetaNavigationFlyoutLink extends mixins(MetaNavigationFlyoutLinkProps, ChildComponentMixin) {
  isFirstItem = false;

  created () {
    this.initChildComponentMixin('MetaNavigationFlyoutLink');
  }

  get rootClass () {
    return {
      'brandhub-meta-navigation-flyout-link--first': this.isFirstItem,
    };
  }

  onItemClick () {
    if (this.linkUrl) {
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Login Flyout', this.linkText, this.linkUrl);
    }
  }
}
